import { actionCreatorFactory } from "typescript-fsa";

const actionCreator = actionCreatorFactory("ROUTER");

export const go = actionCreator<{ to: number }>("GO");
export const pushState = actionCreator<{ path: string }>("PUSH_STATE");
export const replaceState = actionCreator<{ path: string }>("REPLACE_STATE");



// WEBPACK FOOTER //
// ./frontend/src/common/actions/Router.ts